import { OpenStreetMapProvider } from 'leaflet-geosearch';
import Env from 'Services/Env';

window.MapEngine = {
    addressMarkers: [],
    
	popupMap: null,
	editableSticky: true,
	graph: {},
	map: null,
	globalMap: null,
	globalMarkers: {},
	init: function (mapID,lang) {
        
        MapEngine.lang = lang;

		if (Utils.exists(mapID)) {

			//NY par defaut
			var latitude = 40.784148;
			var longitude = -73.966140;
			if(lang === "fr"){
				latitude = 48.8534100;
				longitude = 2.3488000;
			}
            
            MapEngine.map = L.map(mapID);
            
            MapEngine.map.attributionControl.addAttribution('<a href="https://www.jawg.io" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors')
            L.tileLayer('https://tile.jawg.io/jawg-sunny/{z}/{x}/{y}.png?access-token=' + Env.get('jawg').token, {}).addTo(MapEngine.map);

            delete L.Icon.Default.prototype._getIconUrl;

            L.Icon.Default.mergeOptions({
                iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
                iconUrl: require('leaflet/dist/images/marker-icon.png').default,
                shadowUrl: require('leaflet/dist/images/marker-shadow.png').default
            });
            
            MapEngine.map.setView([latitude, longitude], 6);

            var nbAdress = 0;
            var leafletMarkers = [];
            var promises = [];

			$(".addressBlock", "#third-addresses, #people-addresses").each(function () {
                
                var addrid = $('.addressId', this).val();
                
                if(addrid != 0){
					nbAdress ++;
                }
                
                var addressDetails = $('.recap', this).val();
                var lat = $('input[name="lat"]', this).val();
                var lng = $('input[name="lng"]', this).val();
                
                var part1       = $('input[name="part1"]', this).val();
                var zip         = $('input[name="zip"]', this).val();
                var countrycode = $('input[name="countrycode"]', this).val();
                var town        = $('input[name="town"]', this).val();


                if(lat && lng) {
                    
                    MapEngine.addressMarkers[addrid] = {
                        addrid: addrid,
                        lat: lat,
                        lng: lng
                    };

                      leafletMarkers.push(L.marker([lat, lng]).bindPopup(addressDetails).addTo(MapEngine.map));
                } else {
                    
                    $.ajax({
                        "method" : "GET",
                        "url" : "/?_f=address&action=geocode",
                        "data"  : {
                            address : {
                                "part1"         : part1,
                                "zip"           : zip,
                                "countrycode"   : countrycode,
                                "town"          : town,
                                "id"            : addrid  
                            }
                        },
                        "dataType" : "JSON",
                    });
                }


            });
            
            //wait that all addresses have been geocoded before zoom on markers
            if(leafletMarkers.length >= 1){
                var group = new L.featureGroup(leafletMarkers);
                MapEngine.map.fitBounds(group.getBounds().pad(0.5));
            }

			$('form[name=formDirections]').unbind('submit').bind('submit', function () {
				MapEngine.findRoute(MapEngine.map);
				return false;
			});
			MyFacture.initEvent();
			
			
			if(nbAdress == 0){
				setTimeout(function(){
				}, 3000);
			}
		}
	},
	findRoute: function (map) {
		
		var start = $('form[name=formDirections]').find('input[name=start]').val();

		if (start == '') {
			MyWindow.alert(Loc.g('Veuillez Sélectionner une adresse de départ'), {type: "error"});
			return;
        }
        
        
        const provider = new OpenStreetMapProvider();
        
        // search
        
        provider.search({ query: start }).then(function(result){
            
            if(Array.isArray(result) && result[0]) {
                
                var address = result[0];
                    
                var selectedAddress = $('form[name=formDirections]').find('select[name=destination]').val();
                
                if(MapEngine.addressMarkers[selectedAddress]) {
                    MapEngine.setTravel(L.latLng(address.y, address.x), L.latLng(MapEngine.addressMarkers[selectedAddress].lat, MapEngine.addressMarkers[selectedAddress].lng))
                }
                
            }
                
        });
		;
	},
	
	centerToMarker : function(addrid){
		if(MapEngine.addressMarkers[addrid] != undefined){
			MapEngine.map.setView([MapEngine.addressMarkers[addrid].lat, MapEngine.addressMarkers[addrid].lng],16);
		}
	},
		
	setTravel: function (from, to) {

        if(MapEngine.currentRoute){
            MapEngine.map.removeControl(MapEngine.currentRoute);
        } 

        MapEngine.currentRoute = L.Routing.control({
            router : L.Routing.osrmv1({
                serviceUrl  : "https://api.jawg.io/routing/route/v1",
                profile     : "car",
                language    : MapEngine.lang,
                requestParameters : {
                    "access-token" : Env.get('jawg').token,
                },
                useHints : false
            }),
            waypoints: [
                from,
                to
            ],
            draggableWaypoints: false,
            routeWhileDragging: false,
            addWaypoints: false,
            reverseWaypoints: false,
            collapsible: true,            
        }).addTo(MapEngine.map);
		
	},
	
	refresh : function(lang){
		MapEngine.map.refresh(lang);
	}
};
